/**
 * Application-wide constants
 */

export const APP_NAME = 'Fenica'
export const APP_VERSION = '0.0.0'

export const ROUTES = {
  HOME: '/',
  MAT_BANG: '/mat-bang',
  TIEN_ICH: '/tien-ich',
  GALLERY: '/gallery',
  BROCHURE: '/brochure',
  NOT_FOUND: '*',
}
